import { v4 as uuidv4} from 'uuid'

 export const events = [
   {
     id: uuidv4(),
     name: "BIDWIT",
     content:
       "BidWit blended the thrill of an auction with the challenge of a trivia game. Teams bid on trivia questions, with each bid setting the question's value. The winning team earned points by correctly answering the questions, and the team with the highest score emerged victorious, making for an exciting and competitive event.",
      posters: 
        // {src: "/assets/argnBidwit.jpg", label: 2024},
        {src: "/assets/Bidwit_aarohan_25_verified.jpg"}
      
   },

   {
     id: uuidv4(),
     name: "DEATH NOTE",
     content:
       "In Death Note, a crime has been committed, and numerous suspects and pieces of evidence are gathered. Interrogations expose layers of deceit and truth. The challenge is to unravel the mystery, piecing together clues to identify the killer and uncover their motive.",
      posters: 
        // {src: "/assets/arhnDeathNote.jpg", label: 2024},
        {src: "/assets/DEATHNOTE7.png"}
   },
   {
     id: uuidv4(),
     name: "CAR AUCTION",
     content:
       "In the Car Auction, teams used their budget to bid on premium car and supercar parts, strategically assembling the ultimate vehicle. They assessed each component's performance and value, aiming to build a powerhouse machine and gain a competitive edge to secure victory.",
      posters: 
        // {src: "/assets/arhnCarAuction.jpg", label: 2024},
        {src: "/assets/Car Auction_Aarohan copy.png"}
      
   },
   {
     id: uuidv4(),
     name: "ROBOLIGA",
     content:
       "Roboliga, an innovative event by Team AAVISHKAR, featured thrilling one-on-one football matches against intelligent bots, blending football with advanced technology. It showcased participants' leadership and technical skills, creating a competitive atmosphere. The event’s success highlighted the club’s commitment to delivering exceptional experiences.",
      posters: 
        // {src: "/assets/arhnRoboliga.jpg", label: 2024},
        {src: "/assets/Roboliga_Aarohan_25_verified.png"}
      
   },
   {
     id: uuidv4(),
     name: "CROSSVERSE",
     content:
       "In Crossverse, participants united to tackle thrilling challenges, intricate puzzles, and quizzes, showcasing their skills. Running throughout AAROHAN, it was a dynamic experience filled with adrenaline-pumping puzzles and mind-bending riddles that tested wit and quick thinking at every turn.",
      posters: 
        // {src: "/assets/crossword.jpg", label: 2024},
        {src: "/assets/Crossverse_Aarohan1.png"}
      
   },
    {
     id: uuidv4(),
     name: "SPEEDCUBING",
     content:
       "Speedcubing is an electrifying competition where participants race against time to solve a Rubik’s Cube as quickly as possible. Whether you’re a seasoned cuber or just beginning your journey, this is your chance to showcase your reflexes, focus, and problem-solving brilliance.",
      posters: 
        {src: "/assets/SPEEDCUBING.png"}
      
   },
    {
     id: uuidv4(),
     name: "ROBOSUMO",
     content:
       "In Robosumo, strength meets strategy and precision defines victory. Watch as two bots face off in a battle of skill, control, and power every move a test of engineering brilliance. Feel the adrenaline as innovation takes the spotlight and machines fight for glory. Sparks, strategy, and sheer determination only one bot will emerge supreme.",
      posters: 
        {src: "/assets/Robosumo_Aarohan.png"}
      
   },
    {
     id: uuidv4(),
     name: "IOT WORKSHOP",
     content:
       "In the ethical hacking using IoT workshop, you will dive deep into the real-world world of connected devices, learn the tools of a hacker, and become the guardian of the Internet of Things. ",
      posters: 
        {src: "/assets/IoT Workshop Poster_Aarohan.png"}
      
   },
    {
     id: uuidv4(),
     name: "AQUA RACE",
     content:
       "In Aqua Race, the  water gets wild and your bots come alive. Twist, turn, and zoom through the track in a high-speed face-off of skill, precision, and pure adrenaline.It is not just about speed - navigate tricky currents, dodge obstacles, and outsmart your competition to claim the ultimate victory. Every move counts, and every second could make the difference between glory and defeat.",
      posters: 
        {src: "/assets/AQUA RACE 1.png"}
      
   },
 ];

 export const arhn_gallary = [
   {
     id: uuidv4(),
     posters: "/assets/img1.jpg",
    },
   {
     id: uuidv4(),
      posters: "/assets/img3.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/20240409_221145.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img2.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img4.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img10.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img11.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img12.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img13.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img5.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img6.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/IMG_4552.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img9.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/IMG_4746.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img7.jpg",
   },
   {
     id: uuidv4(),
      posters: "/assets/img8.jpg",
   },
  //   {
  //    id: uuidv4(),
  //     posters: "/assets/IMG-20240411-WA0079.jpg",
  //  },
 ];
 
//  export const organizers = [
//    {
//      url: "https://live.staticflickr.com/65535/52770752569_2b8ecca0dc_n.jpg",
//      name: "Rahul Kashyap",
//      position: "President",
//      instaLink: "https://instagram.com/rahulkshp64?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/meetrahulkashyap/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770839734_5e031c3c8c_n.jpg",
//      name: "Vaibhav Ojha",
//      position: "Joint Secretary",
//      instaLink: "https://instagram.com/vaibhav___ojha?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/vaibhav-ojha-2bb06a224/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770963502_3bf0621ced_n.jpg",
//      name: "Ayushi Gupta",
//      position: "Joint Secretary",
//      instaLink: "https://instagram.com/_ayug_?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/ayushi-gupta-8444b2202/",
//    },

//    {
//      url: "https://live.staticflickr.com/65535/52769982052_1439e8a056_n.jpg",
//      name: "Sandeep Verma",
//      position: "Treasurer",
//      instaLink: "https://instagram.com/vsandeep13?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/vsan13/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770777144_ceb4de8b33_n.jpg",
//      name: "Asif Khan",
//      position: "Vice President",
//      instaLink: "https://instagram.com/asif_khan1911?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/asif-khan-a1489964/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770737614_0e22c3bba8_w.jpg",
//      name: "D. Sharvani Reddy",
//      position: "Vice President",
//      instaLink: "https://instagram.com/sharvani_reddyy?igshid=YmMyMTA2M2Y=",
//      linkedinLink:
//        "https://www.linkedin.com/in/sharvani-reddy-dommata-8444b8210/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52771752264_f93e99eaf8_w.jpg",
//      name: "Neel Kamal",
//      position: "Convenor",
//      instaLink: "https://instagram.com/_hyperconjugate_?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/neel-kamal1407/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52769989932_96e6a564c0_n.jpg",
//      name: "Asutosh Kumar Singh Rathore",
//      position: "Head of Corporate Communications",
//      instaLink: "https://instagram.com/simp0la?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/ashutosh-rathore-133b58177",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770762544_ca5e536294_n.jpg",
//      name: "Subham Paul",
//      position: "Head of Operations",
//      instaLink: "https://instagram.com/x_subham_d?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/subham-paul-900320207/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770963442_7e8504f832_n.jpg",
//      name: "Ishan Gupta",
//      position: "Head of Operations",
//      instaLink: "https://instagram.com/ishangupta641?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/ishan-gupta-0652611b8/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770963562_eb41760b38_w.jpg",
//      name: "Navin Kumar Pathak",
//      position: "Technical Head",
//      instaLink: "https://instagram.com/kumarpathaknavin?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/navin-kumar-pathak-a421a1235/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770985890_14ec284834_n.jpg",
//      name: "Sunay Pal",
//      position: "Technical Head",
//      instaLink: "https://instagram.com/palsunay?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/sunay-pal-917035201/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770958238_a1d772fb5c_w.jpg",
//      name: "Ravi Prakash",
//      position: "BAJA Coordinator",
//      instaLink: "https://instagram.com/itz._ravi?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/ravi-prakash-036a13200/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770543366_761f532d74_z.jpg",
//      name: "Sabharish Sappa",
//      position: "Creative Head",
//      instaLink: "https://instagram.com/sabharish_sappa?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/sabharish-sappa-ba62a3216",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52771020693_7da5f3bd3a_n.jpg",
//      name: "Faria Tariq",
//      position: "Creative Head",
//      instaLink: "https://instagram.com/tariqfaria23?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/tariqfaria23",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770534016_72a7436c14_n.jpg",
//      name: "Harsh Srivastava",
//      position: "Publicity Head",
//      instaLink: "https://instagram.com/harshsrivastav521?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/harsh-srivastava-11652b1b7",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770962720_9e830240db_w.jpg",
//      name: "Shivanshu  Basu Mallik",
//      position: "Publicity Head",
//      instaLink:
//        "https://instagram.com/shivanshu_basumallick?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/sbmallick",
//    },

//    {
//      url: "https://live.staticflickr.com/65535/53127082214_560dc78757_n.jpg",
//      name: "Kushal Sarda",
//      position: "WEBD Head",
//      instaLink: "https://instagram.com/kumarpathaknavin?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/kushal-sarda-0126251aa/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52771494371_b5647c9349_n.jpg",
//      name: "Sujal Gupta",
//      position: "WEBD Head",
//      instaLink: "https://instagram.com/sujalgupta628?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/sujal-gupta-436752201/",
//    },
//    {
//      url: "https://live.staticflickr.com/65535/52770810594_44afa91a13_n.jpg",
//      name: "Shraddha Mandal",
//      position: "Head ATH",
//      instaLink: "https://instagram.com/srd_282?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/shraddha-mandal-52b02620a",
//    },

//    {
//      url: "https://live.staticflickr.com/65535/53126284227_4a0c1c0c46_m.jpg",
//      name: "M. Vishnu Vardhan Reddy",
//      position: "Head ATH",
//      instaLink: "https://instagram.com/vvreddy_2709?igshid=YmMyMTA2M2Y=",
//      linkedinLink:
//        "https://www.linkedin.com/in/vishnu-vardhan-reddy-maddi-0b8615218",
//    },

//    {
//      url: "https://live.staticflickr.com/65535/52771005658_7ed79be0eb_n.jpg",
//      name: "Subham Mandal",
//      position: "Event Head",
//      instaLink: "https://instagram.com/subham_mandal?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/subham-mandal-8a18961b6/",
//    },

//    {
//      url: "https://live.staticflickr.com/65535/52770812484_b2e8ae8b60_w.jpg",
//      name: "Shruti Sharma",
//      position: "Event Head",
//      instaLink: "https://instagram.com/shruti.sh_01?igshid=YmMyMTA2M2Y=",
//      linkedinLink: "https://www.linkedin.com/in/shruti-sharma-bb0b6820b/",
//    },

//    {
//      url: "https://live.staticflickr.com/65535/52771494461_96e011d3ab_w.jpg",
//      name: "Sankalp Mohanty",
//      position: "Workshop Head",
//      instaLink: "/",
//      linkedinLink: "/",
//    },

//    {
//      url: "https://live.staticflickr.com/65535/52771983018_12d616e1b2_n.jpg",
//      name: "K. Deekshita",
//      position: "Workshop Head",
//      instaLink: "/",
//      linkedinLink: "https://www.linkedin.com/in/deekshita-kancharla-35616a218/",
//    },
 // ];

 

 
